import clsx from 'clsx';
import { Flex, Table } from '@mantine/core';
import { dateFormat } from '@/lib/utils/date';
import StatusMsg from '@/components/common/status-msg';
import { SecBoxLoader } from '@/components/layout/sec-box';
import EmptyNotification from '@/components/common/empty-states/empty-notification';

const AlertsData = ({ notificationData, error, loading }) => {
    const tableRow = (v, i) => (
        <Table.Tr key={i}>
            <Table.Td style={{ width: '38%' }}>
                <Flex align="center" gap="sm">
                    <div className="circle success_clr"></div>
                    <span>{v?.message}</span>
                </Flex>
            </Table.Td>
            <Table.Td style={{ width: '30%' }}>
                <span>User: {v?.sender?.username}</span>
            </Table.Td>
            <Table.Td>
                <span>{dateFormat(v?.createdAt)}</span>
            </Table.Td>
        </Table.Tr>
    );

    return (
        <>
            {loading ? (
                <SecBoxLoader />
            ) : error?.message ? (
                <div className={'grid_place_center'}>
                    <EmptyNotification />
                </div>
            ) : (
                <Table.ScrollContainer className={clsx('theme_table radius_none sec_box_table')} minWidth={'50rem'} offsetScrollbars={false}>
                    <Table striped withTableBorder>
                        <Table.Tbody>{notificationData?.map((v, i) => tableRow(v, i))}</Table.Tbody>
                    </Table>
                </Table.ScrollContainer>
            )}
        </>
    );
};

export default AlertsData;
